import { LandingPageMode, landingPageViewState } from "./LandingPageViewState";
import { mutatorAction } from "satcheljs";

export default mutatorAction("setLandingPageMode", function setLandingPageMode(
    landingPageMode: LandingPageMode
) {
    landingPageViewState().landingPageMode = landingPageMode;
});